(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react')) :
	typeof define === 'function' && define.amd ? define(['react'], factory) :
	(global.reactNanoSpinner = factory(global.React));
}(this, (function (React) { 'use strict';

function __$styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

React = React && React.hasOwnProperty('default') ? React['default'] : React;

__$styleInject("._nano-spinner-bounce_nek7r_1 {\n  margin: 0 auto;\n  width: 70px;\n  text-align: center;\n  color: black;\n}\n\n._nano-spinner-bounce_nek7r_1 > div {\n  width: 18px;\n  height: 18px;\n  background-color: currentColor;\n\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: _sk-bouncedelay_nek7r_1 1.4s infinite ease-in-out both;\n  animation: _sk-bouncedelay_nek7r_1 1.4s infinite ease-in-out both;\n}\n\n._nano-spinner-bounce_nek7r_1 ._bounce1_nek7r_19 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n._nano-spinner-bounce_nek7r_1 ._bounce2_nek7r_24 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n@-webkit-keyframes _sk-bouncedelay_nek7r_1 {\n  0%, 80%, 100% { -webkit-transform: scale(0) }\n  40% { -webkit-transform: scale(1.0) }\n}\n\n@keyframes _sk-bouncedelay_nek7r_1 {\n  0%, 80%, 100% {\n      -webkit-transform: scale(0);\n      transform: scale(0);\n  } 40% {\n        -webkit-transform: scale(1.0);\n        transform: scale(1.0);\n    }\n}", {});
var css = { "nano-spinner-bounce": "_nano-spinner-bounce_nek7r_1", "sk-bouncedelay": "_sk-bouncedelay_nek7r_1", "bounce1": "_bounce1_nek7r_19", "bounce2": "_bounce2_nek7r_24" };

var ReactNanoSpinner = function ReactNanoSpinner(_ref) {
  var className = _ref.className,
      style = _ref.style;
  return React.createElement(
    'div',
    { className: ('nano-spinner-bounce ' + css['nano-spinner-bounce'] + ' ' + (className || '')).trim(), style: style },
    React.createElement('div', { className: css['bounce1'] }),
    React.createElement('div', { className: css['bounce2'] }),
    React.createElement('div', { className: css['bounce3'] })
  );
};

return ReactNanoSpinner;

})));
